import React ,{useEffect} from 'react';
import { useHistory } from "react-router-dom";



export default function useNavigate({granted,channelCode}){
    const history = useHistory();
    const navigate =(granted,channelCode)=>{
        if(channelCode === "suscript"){
            if(granted)  history.push('/aprobaciones')
          }else{
            if(granted)  history.push('/productos') 
          }
    }

    useEffect(()=>{
        navigate(granted,channelCode);
    },[granted,channelCode])

}